export const formattedGlobalDate = (dateString, fallback = "") => {
    try {
        if (!dateString) {
            return fallback;
        }

        const rawDate = String(dateString).trim();
        const dateParts = rawDate.match(
            /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/
        );

        if (!dateParts) {
            return fallback;
        } 

        const [, year, month, day, hour, minute, second = "00"] = dateParts;
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    } catch (error) {
        return fallback;
    }
}; 

//Changues

export const formatElapsedReportTime = (dateString, currentTime = Date.now()) => {
    const reportTime = new Date(dateString).getTime();
    if (!Number.isFinite(reportTime)) return "—";

    const elapsedMinutes = Math.max(0, Math.floor((currentTime - reportTime) / 60000));
    if (elapsedMinutes < 1) return "menos de 1 min";
    if (elapsedMinutes < 60) return `${elapsedMinutes} min`;

    const elapsedHours = Math.floor(elapsedMinutes / 60);
    const minutes = elapsedMinutes % 60;
    if (elapsedHours < 24) return `${elapsedHours} h ${minutes} min`;

    const elapsedDays = Math.floor(elapsedHours / 24);
    const hours = elapsedHours % 24;
    return `${elapsedDays} d ${hours} h`;
};

export function formatMinutesToHoursAndMinutes(totalMinutes) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}H ${minutes}MIN`;
}
